import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UserProperties } from 'api/ApiClient';
import { apiClient } from 'api/ApiClient';

export const useUpdateProperties = () => {
  const queryCache = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: (newUserProperties: UserProperties) => {
      return apiClient.updateProperties(newUserProperties);
    },
    onSuccess: (data) => {
      queryCache.setQueryData(['getProperties'], () => {
        return data;
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return {
    updateProperties: mutate,
  };
};
